var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchBarContainer"},[_c('b-icon-search',{staticClass:"searchIcon"}),_c('input',{staticClass:"searchBarInput",attrs:{"type":"text","placeholder":"Recherche"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }